import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { createPersistingErrorModule } from '@evidentid/dashboard-commons/modules/persisting-error';
import { createSnackbarModule } from '@evidentid/dashboard-commons/modules/snackbar';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import { NotificationName } from '@evidentid/gateway-api-client/src/models';
import { NotificationType } from '@evidentid/tprm-portal-lib/models/notification-configuration';
import {
    VerificationRequestType,
} from '@evidentid/tprm-portal-lib/models/notification-configuration/VerificationRequest.model';

import SendTestEmailProcedure from '@/modules/notifications-configuration/procedures/SendTestEmailProcedure.vue';

import EditEmailTemplateProcedure from './procedures/EditEmailTemplateProcedure.vue';
import SetNotificationEnablementProcedure from './procedures/SetNotificationEnablementProcedure.vue';
import SetRemindersProcedure from './procedures/SetRemindersProcedure.vue';
import BrandingSettings from './views/BrandingSettings.vue';
import EmailContent from './views/EmailContent.vue';
import EmailNotificationSettings from './views/EmailNotificationSettings.vue';
import SupportContactInformation from './views/SupportContactInformation.vue';

const legacyRoutesRedirect = [
    {
        path: '/:rpId?/admin/email-settings/configuration',
        redirect: '/:rpId?/notifications/email-settings',
    }, {
        path: '/:rpId?/admin/email-settings/templates',
        redirect: '/:rpId?/notifications/email-content',
    }, {
        path: '/:rpId?/admin/notifications/branding',
        redirect: '/:rpId?/notifications/branding',
    }, {
        path: '/:rpId?/admin/notifications/support',
        redirect: '/:rpId?/notifications/contact',
    },
];

export function createNotificationsConfigurationModule() {
    return createModuleBuilder()
        .demandContext<{
        gatewayClient: GatewayApiClient;
    }>()
        .registerRoutes(() => [
            {
                path: '/:rpId?/notifications/email-content',
                name: 'notifications-email-content',
                component: EmailContent as any,
                meta: { title: 'Email Content', pageClass: 'EmailContent' },
            },
            {
                path: '/:rpId?/notifications/email-settings',
                name: 'notifications-email-settings',
                component: EmailNotificationSettings as any,
                meta: { title: 'Email Notifications', pageClass: 'EmailNotificationSettings' },
            },
            {
                path: '/:rpId?/notifications/branding',
                name: 'notifications-branding-settings',
                component: BrandingSettings as any,
                meta: { title: 'Branding Settings' },
            },
            {
                path: '/:rpId?/notifications/contact',
                name: 'notifications-support-contact',
                component: SupportContactInformation as any,
                meta: { title: 'Support Contact Information' },
            },
            ...legacyRoutesRedirect,
        ])
        .demand<ReturnType<typeof createPersistingErrorModule>>()
        .demand<ReturnType<typeof createSnackbarModule>>()
        .registerProcedures<{
        setNotificationReminders: { rpName: string, type: NotificationName };
        setNotificationEnablement: { rpName: string, type: NotificationType };
        editNotificationEmailTemplate: { rpName: string, type: NotificationType };
        sendTestEmail: { rpName: string, type: VerificationRequestType };
    }>({
            setNotificationReminders: SetRemindersProcedure,
            setNotificationEnablement: SetNotificationEnablementProcedure,
            editNotificationEmailTemplate: EditEmailTemplateProcedure,
            sendTestEmail: SendTestEmailProcedure,
        })
        .end();
}

export type NotificationsConfigurationModule = ReturnType<typeof createNotificationsConfigurationModule>;
